// extracted by mini-css-extract-plugin
export default {"overlayStyle":"fakePaymentForm-module__overlayStyle___ijjMs","fakePaymentFormStyle":"fakePaymentForm-module__fakePaymentFormStyle___ohYSH"};